/**
 * Permit easy multi kind of upload
 */
export class KindOfUpload {
  public static NONE = 'NONE';
  public static LRE = 'LRE';
  public static LETTER = 'UNIT';
  public static MULTI_UNIT = 'MULTI-UNIT';
  public static MAILING = 'PUBLI';
  public static SPOOL = 'SPOOL';
}
